import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { SEO } from '@/components/features/SEO';
import { ROUTES } from '@/constants/routes';
import styles from './Terms.module.css';

export function Terms() {
    const navigate = useNavigate();

    return (
        <div className={styles.page}>
            <SEO
                title="Terminos de Servicio - Peru IA"
                description="Terminos y condiciones de uso de Peru IA. Lee las reglas y responsabilidades al usar nuestra plataforma de asistente electoral."
                url="https://peruhonesto.com/terms"
            />

            <nav className={styles.nav}>
                <div className={styles.navInner}>
                    <button
                        className={styles.backButton}
                        onClick={() => navigate(ROUTES.home)}
                    >
                        <IoChevronBack /> Volver al inicio
                    </button>
                </div>
            </nav>

            <main className={styles.content}>
                <h1>Terminos de Servicio</h1>
                <p className={styles.updated}>Ultima actualizacion: 5 de marzo de 2026</p>

                <section>
                    <h2>1. Aceptacion de los terminos</h2>
                    <p>
                        Al acceder, registrarte o utilizar Peru IA (peruhonesto.com), aceptas cumplir con estos
                        terminos de servicio en su totalidad. Si no estas de acuerdo con alguno de estos terminos,
                        debes dejar de utilizar la plataforma inmediatamente. El registro de una cuenta constituye
                        aceptacion expresa de estos terminos y de nuestra politica de privacidad.
                    </p>
                </section>

                <section>
                    <h2>2. Descripcion del servicio</h2>
                    <p>
                        Peru IA es una plataforma de inteligencia artificial disenada exclusivamente para proporcionar
                        informacion sobre las elecciones generales de Peru 2026. El servicio permite a los usuarios
                        hacer preguntas sobre candidatos, partidos politicos y propuestas electorales.
                    </p>
                    <p>
                        La informacion proporcionada se basa en los planes de gobierno oficiales registrados ante
                        el Jurado Nacional de Elecciones (JNE) y otras fuentes oficiales publicas.
                    </p>
                </section>

                <section>
                    <h2>3. Naturaleza informativa - No es asesoria</h2>
                    <p>
                        <strong>Peru IA es una herramienta exclusivamente informativa.</strong> Todo el contenido
                        generado por la plataforma tiene caracter meramente informativo y educativo. Bajo ninguna
                        circunstancia debe interpretarse como:
                    </p>
                    <ul>
                        <li>Recomendacion, sugerencia o indicacion de voto a favor o en contra de ningun candidato o partido politico.</li>
                        <li>Asesoria legal, politica, estrategica o de cualquier otra naturaleza profesional.</li>
                        <li>Respaldo, apoyo, promocion o patrocinio de ningun candidato, partido politico, organizacion o ideologia.</li>
                        <li>Informacion oficial del Estado peruano, del JNE, ONPE, RENIEC o cualquier otra entidad publica.</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Independencia y neutralidad</h2>
                    <p>
                        Peru IA es un proyecto independiente desarrollado por Qolca como aporte a la comunidad.
                        <strong> No tenemos afiliacion, vinculo, acuerdo ni relacion de ninguna naturaleza con ningun
                        candidato, partido politico, organizacion politica, movimiento regional, alianza electoral
                        ni entidad gubernamental.</strong>
                    </p>
                    <p>
                        No recibimos financiamiento, instrucciones ni beneficios de ningun actor politico.
                        No participamos en campanas electorales ni en actividades de proselitismo politico.
                    </p>
                </section>

                <section>
                    <h2>5. Limitaciones de la inteligencia artificial</h2>
                    <p>
                        El usuario reconoce y acepta que la inteligencia artificial utilizada en esta plataforma:
                    </p>
                    <ul>
                        <li><strong>Puede cometer errores.</strong> Las respuestas pueden contener imprecisiones, errores de interpretacion, omisiones o informacion desactualizada.</li>
                        <li><strong>No reemplaza la lectura directa de fuentes oficiales.</strong> El usuario debe verificar cualquier informacion con los documentos originales del JNE.</li>
                        <li><strong>Puede malinterpretar preguntas.</strong> Las respuestas dependen de la formulacion de la pregunta y del contenido disponible en la base de datos.</li>
                        <li><strong>No cubre informacion en tiempo real.</strong> No procesamos noticias, declaraciones de campana, encuestas ni eventos recientes.</li>
                        <li><strong>No tiene opinion.</strong> Cualquier percepcion de sesgo o preferencia en las respuestas es involuntaria y producto de las limitaciones inherentes de la tecnologia.</li>
                    </ul>
                </section>

                <section>
                    <h2>6. Exoneracion de responsabilidad</h2>
                    <p>
                        <strong>En la maxima medida permitida por la ley aplicable, Peru IA, Qolca y sus desarrolladores,
                        empleados, directivos, socios y colaboradores quedan exonerados de toda responsabilidad por:</strong>
                    </p>
                    <ul>
                        <li>Cualquier decision que el usuario tome basandose total o parcialmente en la informacion proporcionada por la plataforma, incluyendo pero no limitandose a decisiones de voto.</li>
                        <li>Errores, imprecisiones, omisiones o malinterpretaciones en las respuestas generadas por la IA.</li>
                        <li>Danos directos, indirectos, incidentales, consecuentes, especiales o punitivos de cualquier naturaleza derivados del uso o la imposibilidad de uso de la plataforma.</li>
                        <li>Malentendidos, confusiones o interpretaciones erroneas que surjan de las respuestas proporcionadas.</li>
                        <li>La percepcion de que alguna respuesta favorece, perjudica, promueve o denigra a algun candidato, partido o movimiento politico.</li>
                        <li>Perdida de datos, interrupcion del servicio o cualquier problema tecnico.</li>
                        <li>Contenido de anuncios de terceros mostrados en la plataforma.</li>
                        <li>El uso que terceros hagan de la informacion obtenida a traves de la plataforma.</li>
                    </ul>
                    <p>
                        El usuario utiliza Peru IA bajo su propio riesgo y responsabilidad. La plataforma se
                        proporciona &quot;tal cual&quot; y &quot;segun disponibilidad&quot;, sin garantias de ningun tipo,
                        expresas o implicitas, incluyendo pero no limitandose a garantias de exactitud, integridad,
                        idoneidad para un proposito particular o no infraccion.
                    </p>
                </section>

                <section>
                    <h2>7. Indemnizacion</h2>
                    <p>
                        El usuario acepta indemnizar, defender y mantener indemne a Peru IA, Qolca, sus desarrolladores,
                        empleados, directivos y colaboradores frente a cualquier reclamo, demanda, dano, perdida, costo
                        o gasto (incluyendo honorarios legales) que surja de o este relacionado con el uso de la
                        plataforma o la violacion de estos terminos.
                    </p>
                </section>

                <section>
                    <h2>8. Uso aceptable</h2>
                    <p>Al usar Peru IA, te comprometes a:</p>
                    <ul>
                        <li>No utilizar la plataforma para difundir desinformacion o contenido enganoso.</li>
                        <li>No atribuir a Peru IA opiniones, recomendaciones o posiciones politicas que no ha emitido.</li>
                        <li>No intentar manipular, hackear o comprometer la seguridad de la plataforma.</li>
                        <li>No utilizar el servicio para fines comerciales, politicos o de campana electoral sin autorizacion previa.</li>
                        <li>No enviar contenido ofensivo, amenazante o ilegal a traves del chat.</li>
                        <li>No intentar extraer datos masivamente (scraping) de la plataforma.</li>
                        <li>No presentar las respuestas de la IA como declaraciones oficiales de Peru IA o de sus desarrolladores.</li>
                    </ul>
                </section>

                <section>
                    <h2>9. Cuentas de usuario</h2>
                    <p>
                        Puedes usar Peru IA como invitado con funcionalidad limitada (1 conversacion)
                        o crear una cuenta para acceder a funcionalidades completas. Al crear una cuenta:
                    </p>
                    <ul>
                        <li>Eres responsable de mantener la confidencialidad de tu contrasena.</li>
                        <li>Debes proporcionar informacion veraz al registrarte.</li>
                        <li>Aceptas estos terminos de servicio y nuestra politica de privacidad.</li>
                        <li>Nos reservamos el derecho de suspender o eliminar cuentas que violen estos terminos.</li>
                    </ul>
                </section>

                <section>
                    <h2>10. Propiedad intelectual</h2>
                    <p>
                        El contenido, diseno, codigo y marca de Peru IA son propiedad de Qolca.
                        La informacion electoral mostrada proviene de fuentes oficiales publicas (JNE).
                        Los usuarios conservan la propiedad de los mensajes que envian a traves del chat.
                    </p>
                </section>

                <section>
                    <h2>11. Publicidad</h2>
                    <p>
                        Peru IA puede mostrar anuncios proporcionados por Google AdSense.
                        Estos anuncios ayudan a mantener el servicio gratuito para todos los usuarios.
                        No tenemos control sobre el contenido de los anuncios de terceros
                        y no asumimos responsabilidad alguna por los productos o servicios anunciados.
                    </p>
                </section>

                <section>
                    <h2>12. Disponibilidad</h2>
                    <p>
                        Nos reservamos el derecho de modificar, suspender o descontinuar el servicio en cualquier
                        momento sin previo aviso. No seremos responsables ante ti ni ante terceros por cualquier
                        modificacion, suspension o interrupcion del servicio.
                    </p>
                </section>

                <section>
                    <h2>13. Divisibilidad</h2>
                    <p>
                        Si alguna disposicion de estos terminos se considera invalida o inaplicable, las disposiciones
                        restantes continuaran en pleno vigor y efecto. La disposicion invalida sera reemplazada por una
                        disposicion valida que se aproxime lo mas posible a la intencion original.
                    </p>
                </section>

                <section>
                    <h2>14. Cambios a estos terminos</h2>
                    <p>
                        Podemos actualizar estos terminos de servicio periodicamente. Los cambios seran
                        publicados en esta pagina con la fecha de actualizacion correspondiente.
                        El uso continuado de la plataforma despues de cualquier cambio constituye la aceptacion
                        de los nuevos terminos.
                    </p>
                </section>

                <section>
                    <h2>15. Legislacion aplicable y jurisdiccion</h2>
                    <p>
                        Estos terminos se rigen por las leyes de la Republica del Peru.
                        Cualquier disputa, controversia o reclamo que surja de o este relacionado con estos terminos
                        o el uso de la plataforma sera resuelta ante los tribunales competentes de Lima, Peru,
                        renunciando el usuario a cualquier otro fuero que pudiera corresponderle.
                    </p>
                </section>

                <section>
                    <h2>16. Contacto</h2>
                    <p>
                        Si tienes preguntas sobre estos terminos de servicio, puedes contactarnos en{' '}
                        <a href="mailto:info@qolca.org">info@qolca.org</a>.
                    </p>
                </section>
            </main>
        </div>
    );
}
